module.exports = __webpack_public_path__ + "fonts/lucidaGrandeBold.4dacabda.ttf";